__turbopack_context__.v({
  "container": "styles-module__b04mUq__container",
  "shippingMessage": "styles-module__b04mUq__shippingMessage",
});
